import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

/* eslint-disable no-shadow */
import Vue from 'vue';
import Vuex from 'vuex';
import MagicService from '@/service/magic';
import { now } from '@vip-activity/business';
import TicketService from '../service/ticket';
Vue.use(Vuex);
var state = {
  isKillSuccess: false,
  hasTicket: false,
  hasBook: false,
  buyList: undefined,
  orderState: -1,
  inviteUserInfo: undefined,
  receiveInfo: {},
  now: Date.now(),
  remainNum: 0
};
var mutations = {
  setState: function setState(state, payload) {
    state[payload.state] = payload.value;
  }
};
var actions = {
  // 查询是否已预约
  hasBookAct: function hasBookAct(_ref) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var commit, val, res;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit;
              val = null;
              _context.prev = 2;
              _context.next = 5;
              return MagicService.hasBookAct();

            case 5:
              res = _context.sent;
              val = !!res.data.is_book;
              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](2);
              console.error(_context.t0);

            case 12:
              commit('setState', {
                state: 'hasBook',
                value: val
              });

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 9]]);
    }))();
  },
  // 刷新抽奖信息（抽奖次数）
  refreshLotteryInfo: function refreshLotteryInfo(_ref2) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var commit, res, _res$data$left_num, leftNum;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref2.commit;
              _context2.next = 3;
              return MagicService.getLotteryInfo();

            case 3:
              res = _context2.sent;
              _res$data$left_num = res.data.left_num, leftNum = _res$data$left_num === void 0 ? 0 : _res$data$left_num;
              commit('setState', {
                state: 'remainNum',
                value: leftNum
              });

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  getBuyList: function getBuyList(_ref3) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var commit, res;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              commit = _ref3.commit;
              _context3.prev = 1;
              _context3.next = 4;
              return TicketService.getBuyList();

            case 4:
              res = _context3.sent;
              commit('setState', {
                state: 'buyList',
                value: res.list || []
              });
              _context3.next = 11;
              break;

            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](1);
              commit('setState', {
                state: 'buyList',
                value: null
              });

            case 11:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[1, 8]]);
    }))();
  },
  checkHasTicket: function checkHasTicket(_ref4) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var commit, val;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              commit = _ref4.commit;
              _context4.next = 3;
              return TicketService.getHasZhiboTicket().then(function (res) {
                return res.payStatus !== 0;
              }).catch(function () {
                return false;
              });

            case 3:
              val = _context4.sent;

              if (val) {
                _context4.next = 8;
                break;
              }

              _context4.next = 7;
              return TicketService.getHasDianboTicket().then(function (res) {
                return !!res.cidBuyCheck;
              }).catch(function () {
                return false;
              });

            case 7:
              val = _context4.sent;

            case 8:
              commit('setState', {
                state: 'hasTicket',
                value: val
              });

            case 9:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  },
  getNow: function getNow(_ref5) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      var commit, time;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              commit = _ref5.commit;
              time = Date.now();
              _context5.prev = 2;
              _context5.next = 5;
              return now();

            case 5:
              time = _context5.sent;
              _context5.next = 11;
              break;

            case 8:
              _context5.prev = 8;
              _context5.t0 = _context5["catch"](2);
              console.log(_context5.t0);

            case 11:
              commit('setState', {
                state: 'now',
                value: time
              });

            case 12:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[2, 8]]);
    }))();
  }
};
var getters = {
  isLiveEnd: function isLiveEnd(state) {
    var liveItem = window.setting.时间线[1];
    return liveItem ? liveItem.结束时间 < state.now : false;
  },
  mySupportCount: function mySupportCount() {
    var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : state,
        isKillSuccess = _ref6.isKillSuccess;

    var list = state.buyList || [];
    var total = 0;
    list.forEach(function (item) {
      total += item.iTicketNum;
    });
    return isKillSuccess ? total + 1 : total;
  }
};
export default new Vuex.Store({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});